/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mb-10[_ngcontent-%COMP%]{margin-bottom:10px!important}.text-ellipsis[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}a[_ngcontent-%COMP%]{width:96px;height:96px;margin-bottom:5px}"];
export { styles as styles };
